import { render, staticRenderFns } from "./ModalAdvisory.vue?vue&type=template&id=2ffbc4b4&"
import script from "./ModalAdvisory.vue?vue&type=script&lang=js&"
export * from "./ModalAdvisory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports